
// export const myGetter = ( state ) => {
//  return state
// }

export const vehiclesList = state => state.vehicles
export const vehiclesSelectable = state => state.vehiclesSelectable
export const vehiclesPaginatedData = state => state.vehiclesPaginatedData
export const vehicle = state => state.vehicle
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData